import React from "react";

import { useTranslation, Trans } from "react-i18next";

import vec1 from '../../img/AboutUs/vec1.png';
import vec2 from '../../img/AboutUs/vec2.png';
import vec3 from '../../img/AboutUs/vec3.png';

function OurClients () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto pt-[120px] xl:pt-[160px]">
                <p className="text-[32px] xl:text-[40px] italic font-[700] merriweather text-center"><Trans>{t('about.16')}</Trans></p>
                <div className="flex flex-wrap justify-center md:justify-between mt-[50px] xl:mt-[65px] gap-[30px]">
                    <div className="flex flex-col items-center w-[170px] md:w-auto">
                        <img src={vec1} alt="" />
                        <p className="fdfd text-center leading-[1.2] mt-[25px] open-sans text-[16px] xl:text-[20px]"><Trans>{t('about.17')}</Trans></p>
                    </div>
                    <div className="flex flex-col items-center w-[170px] md:w-auto">
                        <img src={vec2} alt="" />
                        <p className="fdfd text-center leading-[1.2] mt-[25px] open-sans text-[16px] xl:text-[20px]"><Trans>{t('about.18')}</Trans></p>
                    </div>
                    <div className="flex flex-col items-center w-[170px] md:w-auto">
                        <img src={vec3} alt="" />
                        <p className="fdfd text-center leading-[1.2] mt-[25px] open-sans text-[16px] xl:text-[20px]"><Trans>{t('about.19')}</Trans></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OurClients;